import { Flex } from 'foundations-components/components/Flex';
import { useHasFoldersTab } from 'framework-listing-lib/internal/Folders/hooks/useFolderProps';
import LoadingSkeleton from 'framework-listing-lib/internal/shared/components/LoadingSkeleton';
import { useHasFoldersMode, useIsFoldersMode } from 'framework-listing-lib/internal/hooks/useUIMode';
import { useHasViews } from 'framework-listing-lib/internal/ViewTabs/hooks/useViewProps';
import { DEFAULT_PADDING_TOKEN } from 'framework-listing-lib/constants/sizes';
import { CrmListingFilterBar } from './CrmListingFilterBar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function CrmListingFiltersSkeleton() {
  const hasViews = useHasViews();
  const hasFoldersTab = useHasFoldersTab();
  const isFoldersMode = useIsFoldersMode();
  const hasFoldersMode = useHasFoldersMode();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(CrmListingFilterBar, {
      "data-test-id": "filter-bar-skeleton",
      hasViews: hasViews,
      isFoldersMode: isFoldersMode,
      endSlot: hasViews && !isFoldersMode ? /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        "data-test-id": "save-view-button-skeleton",
        blockSize: "40px",
        children: /*#__PURE__*/_jsx(LoadingSkeleton, {
          blockSize: "16px",
          marginInlineStart: "300",
          inlineSize: "100px"
        })
      }) : null,
      startSlot: /*#__PURE__*/_jsxs(_Fragment, {
        children: [hasFoldersMode && !hasFoldersTab && !isFoldersMode && /*#__PURE__*/_jsxs(Flex, {
          "data-test-id": "ui-mode-toggle-skeleton-crm-ui",
          marginInlineStart: hasViews ? DEFAULT_PADDING_TOKEN : '0',
          inlineSize: "120px",
          children: [/*#__PURE__*/_jsx(LoadingSkeleton, {
            blockSize: "32",
            inlineSize: "60px"
          }), /*#__PURE__*/_jsx(LoadingSkeleton, {
            blockSize: "32",
            inlineSize: "60px"
          })]
        }), /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          "data-test-id": "filter-component-skeleton-one",
          blockSize: "40px",
          children: /*#__PURE__*/_jsx(LoadingSkeleton, {
            blockSize: "16",
            marginInlineStart: DEFAULT_PADDING_TOKEN,
            inlineSize: "100px"
          })
        }), /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          "data-test-id": "filter-component-skeleton-two",
          blockSize: "40px",
          children: /*#__PURE__*/_jsx(LoadingSkeleton, {
            blockSize: "16",
            marginInlineStart: DEFAULT_PADDING_TOKEN,
            inlineSize: "100px"
          })
        })]
      })
    })
  });
}